import http from '../http'

export default {
  // ================= 基础 / 公会信息 =================
  // 获取公会信息-v2
  getGuildInfo(data: object) {
    return http.post('/web/guild/info', data)
  },
  // 获取用户公会信息-v2
  getMyGuildInfo(data: object) {
    return http.post('/web/guild/my', data)
  },
  // 搜索公会-v2
  getGuildList(data: object) {
    return http.post('/web/guild/list', data)
  },
  // 搜索公会-v2 (useRequest Hook)
  useQueryGuildList(data: object) {
    return http.usePost('/web/guild/list', data)
  },
  // 公会等级详情
  getGuildLevelDetail(data: object) {
    return http.post('/web/guild/level_detail', data)
  },
  // 公会主页 banner 广告
  getGuildBanner(data: object) {
    return http.post('/web/guild/banner', data)
  },

  // ================= 创建 / 加入 / 退出 =================
  // 申请创建公会
  createGuild(data: object) {
    return http.post('/web/guild/apply_create', data)
  },
  // 公会申请列表（创建公会申请）
  getGuildCreateApplyList(data: object) {
    return http.post('/web/guild/apply_create_list', data)
  },
  // 同意或者拒绝创建公会
  handleGuildCreateApply(data: object) {
    return http.post('/web/guild/apply_create_process', data)
  },
  // 申请加入公会-v2
  applyGuildJoin(data: object) {
    return http.post('/web/guild/apply_join', data)
  },
  // 获取公会加入申请列表-v2
  getGuildApplyList(data: object) {
    return http.post('/web/guild/apply_list', data)
  },
  // 处理申请加入消息-v2
  handleGuildApplyProcess(data: object) {
    return http.post('/web/guild/apply_process', data)
  },
  // 自助退出公会
  leaveGuild(data?: object) {
    return http.post('/web/guild/leave', data)
  },

  // ================= 成员 / 粉丝管理 =================
  // 公会主播列表-v2
  getGuildMemberList(data: object) {
    return http.post('/web/guild/member', data)
  },
  // 移除主播-v2
  removeGuildMember(data: object) {
    return http.post('/web/guild/member/remove', data)
  },
  // 设置或者取消管理员-v2
  setGuildMemberRole(data: object) {
    return http.post('/web/guild/member/set_role', data)
  },
  // 获取主播在麦信息-v2
  getGuildMemberOnMicList(data: object) {
    return http.post('/web/guild/member/on_mic_list', data)
  },
  // 成员视角主页
  getGuildMemberHome(data: object) {
    return http.post('/web/guild/member/home', data)
  },
  // 成员视角-公会成员列表
  getGuildMemberHomeMembers(data: object) {
    return http.post('/web/guild/member/home/members', data)
  },
  // 获取可邀请的粉丝-v2
  getGuildFansList(data: object) {
    return http.post('/web/guild/can_invite_fans', data)
  },
  // 邀请粉丝加入公会-v2
  inviteGuildFans(data: object) {
    return http.post('/web/guild/invite_fans', data)
  },
  // 粉丝通过邀请加入公会-v2
  joinGuildByInvite(data: object) {
    return http.post('/web/guild/join_invite', data)
  },

  // ================= 账单 / 薪资 / 流水 =================
  // 公会账单
  getGuildBill(data: object) {
    return http.post('/web/guild/bill', data)
  },
  // 公会账单列表
  getGuildBillList(data: object) {
    return http.post('/web/guild/bill/list', data)
  },
  // 获取公会的账期列表-v3
  getGuildBillPeriod(data: object) {
    return http.post('/web/guild/bill_period', data)
  },
  // 公会用户账单（个人账单）
  getPersonalBill(data: object) {
    return http.post('/web/guild/member/bill', data)
  },
  // 公会成员账单列表（个人账单列表）
  getPersonalBillList(data: object) {
    return http.post('/web/guild/member/bill/List', data)
  },
  // 成员账单列表
  getGuildMemberBillList(data: object) {
    return http.post('/web/guild/member/bill/list', data)
  },
  // 流水-v2
  getGuildMemberCoins(data: object) {
    return http.post('/web/guild/member/coins', data)
  },
  // 新区薪资流水-v2
  getGuildMemberCoinsRu(data: object) {
    return http.post('/web/guild/member/coins_ru', data)
  },
  // 获取主播薪资、会长薪资-v2
  getGuildSalaryInfo(data: object) {
    return http.post('/web/guild/salary_info', data)
  },
  // 会员薪资信息-v2
  getGuildMemberSalaryList(data: object) {
    return http.post('/web/guild/member_salary_list', data)
  },
  // 公会薪资等级配置-v2
  getGuildSalarySetting(data: object) {
    return http.post('/web/guild/salary_setting', data)
  },
  // 公会薪资等级配置-v3
  getGuildSalarySettingV3(data: object) {
    return http.post('/web/guild/salary_setting_v3', data)
  },

  // ================= 外管 / BD 管理 =================
  // 获取外管或者BD的公会列表
  getBindGuildList(data: object) {
    return http.post('/web/guild/guild_list', data)
  },
  // BD成员列表
  getGuildBDMemberList(data: object) {
    return http.post('/web/guild/bd_member', data)
  },
  // 上级外管列表
  getGuildParentList(data: object) {
    return http.post('/web/guild/ext_admin', data)
  },
  // 获取阿语区邀请者ID
  getGuildInviteAreaID(data: object) {
    return http.post('/web/guild/get_ar_inviter_uid', data)
  },
  // 获取外管或者BD用户信息
  getExtAdminBdInfo(data: object) {
    return http.post('/web/guild/get_ext_admin_bd_info', data)
  },
  // 获取外管红点
  getGuildExtAdminRedDot(data: object) {
    return http.post('/web/guild/get_ext_admin_red_dot', data)
  },
  // 外管成员列表
  getGuildExtAdminMember(data: object) {
    return http.post('/web/guild/ext_admin_member', data)
  },
  // 获取外管成员总数
  getGuildExtAdminMemberCount(data: object) {
    return http.post('/web/guild/get_ext_admin_member_count', data)
  },
  // 获取个人数据详情
  getPersonalData(data: object) {
    return http.post('/web/guild/get_self_info', data)
  },

  // ================= 数据中心 (DataCenter) =================
  // 数据中心-获取指定时间内公会的基础收礼获得钻石数
  getGuildDataCenterAllDiamondsDate(data: object) {
    return http.post('/web/guild/datacenter/all_diamonds_date', data)
  },
  // 数据中心-获取个人指定时间内的基础收礼获得钻石数
  getGuildDataCenterMemberDiamondsDate(data: object) {
    return http.post('/web/guild/datacenter/member_diamonds_date', data)
  },
  // 数据中心-获取公会旗下所有主播指定时间段的基础收礼获得钻石数
  getGuildDataCenterMemberDiamondsRangeDayList(data: object) {
    return http.post('/web/guild/datacenter/member_diamonds_range_day_list', data)
  },
  // 数据中心-获取公会旗下所有主播的今日基础收礼获得钻石数（已废弃）
  getGuildDataCenterMemberDiamondsTodayList(data: object) {
    return http.post('/web/guild/datacenter/member_diamonds_today_list', data)
  },
  // 数据中心-获取公会旗下主播基础信息
  getGuildDataCenterMemberBaseInfo(data: object) {
    return http.post('/web/guild/datacenter/member/baseinfo', data)
  },
  // 数据中心成员列表
  getGuildDataCenterMembers(data: object) {
    return http.post('/web/guild/datacenter/members', data)
  },
  // 数据中心总览
  getGuildDataCenterOverview(data: object) {
    return http.post('/web/guild/datacenter/overview', data)
  },
}
